import React from 'react';

export const Faq = [
  {
    id: 0,
    question: 'Who should attend?',
    answer: (
      <>
        <p>
          FTX is best-suited for SMEs, startups, fintech experts, product and
          tech enthusiasts, enterprises, government dignitaries, and new-age
          bankers.
        </p>
      </>
    ),
  },

  {
    id: 1,
    question: 'Can I know more about the ticket donations?',
    answer: (
      <>
        <p>
          All proceeds made towards FTX tickets will be donated to CRY India.
          Over the past 41 years, CRY has been ensuring happier childhoods and
          mobilizing India’s citizens to act for India’s children, working on
          all spheres of children’s rights –education, nutrition, healthcare,
          child marriage, child labour and, contributing to public policy to
          ensure that children’s voices are heard and considered.
        </p>

        <p>
          We at Razorpay, have chosen to contribute to one of the country’s
          pillars in the past, present and future- uplifting and providing
          better avenues for children’s education. The donations towards CRY
          will be made on attendees’ behalf by Razorpay.
        </p>
      </>
    ),
  },

  {
    id: 2,
    question: 'What about cancellation/refunds/transfers?',
    answer: (
      <>
        <p>
          Since proceeds made towards FTX tickets are to be donated to CRY, we
          do not encourage cancellation, refund or transfer of tickets.
          Additionally, they cause a lot of back end operational issues. We hope
          you understand.
        </p>
      </>
    ),
  },
  {
    id: 3,
    question: 'What is the lunch situation like?',
    answer: (
      <>
        <p>
          Since FTX 2021 will be a fully virtual event, lunch is not applicable
          this year, unfortunately. However, you can always kick back, relax and
          attend FTX at your convenience with a home-cooked meal. We also have
          special entertainment arrangements for our attendees. Stay tuned for
          more details on the lineup. Do tag us on social media so we can join
          the virtual party, too!
        </p>
        <p>
          Mark your calendars for the 9th and 10th of December, 2021 and get
          ready to be a part of the most awaited fintech event of the year! Got
          any questions? We’ve got you covered.
        </p>
      </>
    ),
  },
  {
    id: 4,
    question: 'Where can I find my ticket? ',
    answer: (
      <>
        <p>
          After registering for your ticket, we will send your ticket to your
          registered email address. You will receive a link that will redirect
          you to the conference check-in page with your registered email
          address.
        </p>
      </>
    ),
  },

  {
    id: 5,
    question: 'What is the difference my ticket will make?',
    answer: (
      <>
        <p>
          While the actual magnitude of change cannot be put in words, here’s a
          quantifiable difference your ticket contributions can make:{' '}
        </p>
        <p>
          <span style={{ color: '#fff' }}>Rs.99</span>– Towards providing
          learning material and worksheets to children without internet access.
        </p>
        <p>
          <span style={{ color: '#fff' }}>Rs.999</span>– Towards helping
          children get access to mental health and personal development support.
        </p>
        <p>
          <span style={{ color: '#fff' }}>Rs.9999</span>– Towards helping fund
          bridge schools for children facing learning gaps due to the pandemic.
        </p>
      </>
    ),
  },
  {
    id: 6,
    question: 'Can I book more than 10 tickets at a time?',
    answer: (
      <>
        <p>
          We currently allow bookings for up to 10 tickets per transaction. But
          we're as excited to host you at FTX 2021, as you are to join us. So if
          you require additional tickets, a simple hack would be to refresh the
          page after you complete registering 10 tickets in your first
          transaction. You can also write to us at ftx@razorpay.com, if you'd
          like to purchase tickets in bulk.
        </p>
      </>
    ),
  },
];
// export const Speakers = [
//   {
//     SpeakerName: 'Meyer Micky Malka',
//   },
//   {
//     SpeakerName: 'Ari Sarker',
//   },
//   {
//     SpeakerName: 'Arundhati Bhattacharya',
//   },
//   {
//     SpeakerName: 'Dilip Asbe',
//   },
//   {
//     SpeakerName: 'Surojit Chatterjee',
//   },
//   {
//     SpeakerName: 'Amitabh Tewary',
//   },
//   {
//     SpeakerName: 'Nitin Gupta',
//   },
//   {
//     SpeakerName: 'Praveena Rai',
//   },

//   {
//     SpeakerName: 'Sanjeev Moghe',
//   },
//   {
//     SpeakerName: 'Pankaj Gadgil',
//   },
//   {
//     SpeakerName: 'Arpit Chug',
//   },
//   {
//     SpeakerName: 'Amrish Rau',
//   },
//   {
//     SpeakerName: 'Rahul Kothari',
//   },

//   {
//     SpeakerName: ' Pradyot Ghate',
//   },
//   {
//     SpeakerName: 'Prashant Aiyar',
//   },
//   {
//     SpeakerName: 'Ankit Mehrotra',
//   },
//   {
//     SpeakerName: 'Gunjan Pradhan',
//   },
//   {
//     SpeakerName: 'Praveen Gopal Krishnan',
//   },
//   {
//     SpeakerName: 'Lizzie Chapman',
//   },
//   {
//     SpeakerName: 'Anurag Sinha',
//   },
//   {
//     SpeakerName: 'Karan Mehta',
//   },
//   {
//     SpeakerName: 'Akshay Mehrotra',
//   },
//   {
//     SpeakerName: 'Ayush Bansal',
//   },

//   {
//     SpeakerName: 'Matthias Setzer',
//   },
//   {
//     SpeakerName: 'Sagar Saxena',
//   },
//   {
//     SpeakerName: 'Anupam Pahuja',
//   },
//   {
//     SpeakerName: 'Michael Seibel',
//   },
//   {
//     SpeakerName: 'Rajan Anandan',
//   },
//   {
//     SpeakerName: 'Manish Patel',
//   },
//   {
//     SpeakerName: 'Ravish Naresh',
//   },
//   {
//     SpeakerName: 'Sairee Chahal',
//   },
//   {
//     SpeakerName: 'Nikhil Arora',
//   },
//   {
//     SpeakerName: 'Vedanarayanan Vedantham',
//   },
//   {
//     SpeakerName: 'Shweta Rajpal Kohli',
//   },
//   {
//     SpeakerName: 'Dr. KV Subramanian',
//   },
//   {
//     SpeakerName: 'Mark Troughton',
//   },
//   {
//     SpeakerName: 'Jitendra Gupta',
//   },

//   {
//     SpeakerName: 'David Vélez',
//   },
//   {
//     SpeakerName: 'Bhavin Turakhia',
//   },
//   {
//     SpeakerName: 'Shashank Mehta',
//   },
//   {
//     SpeakerName: 'Nithin Kamath',
//   },
//   {
//     SpeakerName: 'Harmeen Mehta',
//   },
//   {
//     SpeakerName: 'Akash Saxena',
//   },
//   {
//     SpeakerName: 'Kailash Nadh',
//   },
//   {
//     SpeakerName: 'Saurabh Tandon',
//   },
//   {
//     SpeakerName: 'Raju Shetty',
//   },
//   {
//     SpeakerName: 'Ganesh Ram',
//   },
//   {
//     SpeakerName: 'Ravi Kumar',
//   },
//   {
//     SpeakerName: 'Mukesh Kalra',
//   },
//   {
//     SpeakerName: 'Vasanth Jeyapaul',
//   },
//   {
//     SpeakerName: 'Shanai Ghosh',
//   },
//   {
//     SpeakerName: 'Harsh Gupta',
//   },
//   {
//     SpeakerName: 'Parag Rao',
//   },
//   {
//     SpeakerName: 'Navin Surya',
//   },
//   {
//     SpeakerName: 'T.R. Ramachandran',
//   },
//   {
//     SpeakerName: 'Amitabh  Tewary',
//   },
//   {
//     SpeakerName: 'Kishore Kumar',
//   },
//   {
//     SpeakerName: 'Saranya Gopinath',
//   },
//   {
//     SpeakerName: 'Navneet Nair',
//   },
//   {
//     SpeakerName: 'Dharmesh BA',
//   },
//   {
//     SpeakerName: 'Chetty Arun',
//   },
//   {
//     SpeakerName: 'Amit Kurseja',
//   },
//   {
//     SpeakerName: 'Smrithi Ravichandran',
//   },
//   {
//     SpeakerName: 'Vidit Aatrey',
//   },
//   {
//     SpeakerName: 'Abhiraj Singh Bhal',
//   },
//   {
//     SpeakerName: 'Khilan Haria',
//   },
//   {
//     SpeakerName: 'Kunal Shah',
//   },
// ].map(({ SpeakerName }, id) => ({ SpeakerName, id }));

export const expertSpeakers = [
  {
    speakerName: 'Amitabh Kant',
    speakerDesignation: <>CEO, NITI Aayog</>,

    Speakerimage: 'https://ftx-rp.netlify.app/img/amitabh-kant.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/amitabh-kant.webp',
    linkedinProfile:
      'https://www.linkedin.com/in/amitabh-kant-3680b01b1/?originalSubdomain=in',
  },
  {
    speakerName: 'Lizzie Chapman',
    speakerDesignation: <>Co-Founder &amp; CEO, Zestmoney</>,
    Speakerimage: 'https://ftx-rp.netlify.app/img/lizzie-chapman.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/lizzie-chapman.webp',
    linkedinProfile: 'https://www.linkedin.com/in/lizzie-chapman-a49430/',
  },
  {
    speakerName: 'Ankur Warikoo',
    speakerDesignation: 'Founder,	Nearbuy',
    Speakerimage: 'https://ftx-rp.netlify.app/img/ankur-warikoo.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/ankur-warikoo.webp',
    linkedinProfile: 'https://in.linkedin.com/in/warikoo',
  },
  {
    speakerName: 'Nithin Kamath',
    speakerDesignation: <>Founder and CEO, Zerodha</>,
    Speakerimage: 'https://ftx-rp.netlify.app/img/nitin-kamath.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/nitin-kamath.webp',
    linkedinProfile: 'https://www.linkedin.com/in/nithin-kamath-81136242/',
  },
  {
    speakerName: 'Yashish Dahiya',
    speakerDesignation: <>Chairman, CEO - PB Fintech</>,
    Speakerimage: 'https://ftx-rp.netlify.app/img/yashish-dahiya.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/yashish-dahiya.webp',
    linkedinProfile: 'abc',
  },
  {
    speakerName: 'Shweta Rajpal Kohli	',
    speakerDesignation: (
      <>
        Chief Public Policy Officer,
        <br /> Sequoia Capital
      </>
    ),
    Speakerimage: 'https://ftx-rp.netlify.app/img/shweta-rajpal.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/shweta-rajpal.webp',
    linkedinProfile: 'https://in.linkedin.com/in/shweta-rajpal-kohli-76b98386',
  },

  {
    speakerName: 'Mohit Bedi',
    speakerDesignation: (
      <>
        SVP and Business Head - <br />
        Acquiring and Commercial Cards, Axis Bank
      </>
    ),
    Speakerimage: 'https://ftx-rp.netlify.app/img/mohit-bedi.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/mohit-bedi.webp',
    linkedinProfile: 'https://www.linkedin.com/in/mohit-bedi-764680/',
  },
  {
    speakerName: 'Anand Kumar Bajaj',
    speakerDesignation: 'CEO & Founder,	PayNearby ',
    Speakerimage: 'https://ftx-rp.netlify.app/img/anand-kumar.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/anand-kumar.webp',
    linkedinProfile: 'https://www.linkedin.com/in/anandkumarbajajinnovation/',
  },

  {
    speakerName: 'Shekhar Bhandari',
    speakerDesignation: (
      <>
        President -<br />
        Global Transaction Banking, <br />
        Kotak Mahindra Bank
      </>
    ),
    Speakerimage: 'https://ftx-rp.netlify.app/img/shekhar-bhandari.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/shekhar-bhandari.webp',
    linkedinProfile:
      'https://www.linkedin.com/in/shekhar-bhandari-035405/?originalSubdomain=in',
  },
  {
    speakerName: 'Shinjini Kumar',
    speakerDesignation: <>Co-Founder, SALT</>,
    Speakerimage: 'https://ftx-rp.netlify.app/img/shinjini-kumar.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/shinjini-kumar.webp',
    linkedinProfile: 'https://in.linkedin.com/in/shinjini-kumar-a7b14020',
  },

  {
    speakerName: 'Kishore Kumar',
    speakerDesignation: <> Product Design Lead, Google</>,
    Speakerimage: 'https://ftx-rp.netlify.app/img/kishore-kumar.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/kishore-kumar.webp',
    linkedinProfile: 'https://www.linkedin.com/in/kishore90/',
  },
  {
    speakerName: 'Tejas Goenka',
    speakerDesignation: <> Managing Director, Tally Solutions</>,
    Speakerimage: 'https://ftx-rp.netlify.app/img/tejas-goenka.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/tejas-goenka.webp',
    linkedinProfile: 'https://in.linkedin.com/in/tejas-goenka-3ab25244',
  },

  {
    speakerName: 'Harshil Mathur',
    speakerDesignation: <> CEO, Co-Founder, Razorpay</>,
    Speakerimage: 'https://ftx-rp.netlify.app/img/harshil-mathur.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/harshil-mathur.webp',
    linkedinProfile: 'https://www.linkedin.com/in/harshilmathur/',
  },
  {
    speakerName: 'Shashank Kumar',
    speakerDesignation: <> CTO, Co-Founder, Razorpay</>,
    Speakerimage: 'https://ftx-rp.netlify.app/img/shashank-kumar.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/shashank-kumar.webp',
    linkedinProfile: 'https://www.linkedin.com/in/kumarshashank/',
  },
  {
    speakerName: 'Shashank Mehta',
    speakerDesignation: <>GM/Head - RazorpayX, Razorpay</>,
    Speakerimage: 'https://ftx-rp.netlify.app/img/shashank-mehta.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/shashank-mehta.webp',
    linkedinProfile: 'https://www.linkedin.com/in/mehta-shashank/',
  },
  // {
  //   speakerName: 'Naveen Kukreja',
  //   speakerDesignation: <>CEO, Paisabazaar</>,
  //   Speakerimage: 'https://ftx-rp.netlify.app/img/naveen-kukreja.jpg',
  //   SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/naveen-kukreja.webp',
  //   linkedinProfile:
  //     'https://www.linkedin.com/in/naveen-kukreja-b333013?originalSubdomain=in',
  // },

  {
    speakerName: 'Amitabh Tewary',
    speakerDesignation: <>Chief Innovation Officer, Razorpay</>,
    Speakerimage: 'https://ftx-rp.netlify.app/img/amitabh-tewary.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/amitabh-tewary.webp',
    linkedinProfile: 'https://www.linkedin.com/in/amitabh-tewary-a193982',
  },
  {
    speakerName: 'Saurabh Soni',
    speakerDesignation: <>Head of Design, RazorpayX, Razorpay</>,
    Speakerimage: 'https://ftx-rp.netlify.app/img/saurabh-soni.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/saurabh-soni.webp',
    linkedinProfile: 'https://www.linkedin.com/in/saurabhsoniss/',
  },
  {
    speakerName: 'Rajeev Ahuja',
    speakerDesignation: <>Group Head, RBL Bank</>,
    Speakerimage: 'https://ftx-rp.netlify.app/img/rajeev-ahuja.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/rajeev-ahuja.webp',
    linkedinProfile: 'https://www.linkedin.com/in/rajeev-ahuja-68192516/',
  },
  {
    speakerName: 'Rakesh Bhatt',
    speakerDesignation: <>CEO, Finserv MARKETS</>,
    Speakerimage: 'https://ftx-rp.netlify.app/img/rakesh-bhatt.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/rakesh-bhatt.webp',
    linkedinProfile: 'https://www.linkedin.com/in/bhattrakesh/',
  },

  {
    speakerName: 'Navneet Nair',
    speakerDesignation: <>Director of Product Design, PhonePe</>,
    Speakerimage: 'https://ftx-rp.netlify.app/img/navneet-nair.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/navneet-nair.webp',
    linkedinProfile: 'https://www.linkedin.com/in/navneetnair/',
  },

  {
    speakerName: 'Mukesh Kalra',
    speakerDesignation: <>Founder, ETMONEY</>,
    Speakerimage: 'https://ftx-rp.netlify.app/img/mukesh-kalra.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/mukesh-kalra.webp',
    linkedinProfile: 'https://www.linkedin.com/in/mukeshpkalra/',
  },
  // {
  //   speakerName: 'Anirvan Saha',
  //   speakerDesignation: <>Vice President IT, ICICI Lombard</>,
  //   Speakerimage: 'https://ftx-rp.netlify.app/img/anirvan-saha.jpg',
  //   SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/anirvan-saha.webp',
  //   linkedinProfile: 'https://in.linkedin.com/in/anirvan-saha-075b9513',
  // },
  {
    speakerName: 'Harsh Pokharna',
    speakerDesignation: <>Co-Founder &amp; CEO, OkCredit</>,
    Speakerimage: 'https://ftx-rp.netlify.app/img/harsh-pokharna.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/harsh-pokharna.webp',
    linkedinProfile: 'https://www.linkedin.com/in/harsh-pokharna/',
  },
  {
    speakerName: 'Shanai Ghosh',
    speakerDesignation: (
      <>CEO &amp; Executive Director, Edelweiss General Insurance</>
    ),
    Speakerimage: 'https://ftx-rp.netlify.app/img/shanai-ghosh.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/shanai-ghosh.webp',
    linkedinProfile: 'https://www.linkedin.com/in/shanaighosh/',
  },
  {
    speakerName: 'Sonal Kapoor',
    speakerDesignation: <> Director - Financial Services, Flipkart</>,
    Speakerimage: 'https://ftx-rp.netlify.app/img/sonal-kapoor.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/sonal-kapoor.webp',
    linkedinProfile: 'https://www.linkedin.com/in/sonal-kapoor-a5b1a94b/',
  },
  {
    speakerName: 'Rahul Kothari',
    speakerDesignation: <>Chief Business Officer, Razorpay</>,
    Speakerimage: 'https://ftx-rp.netlify.app/img/rahul-kothari.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/rahul-kothari.webp',
    linkedinProfile: 'https://www.linkedin.com/in/rahulkothari/',
  },
  // {
  //   speakerName: 'Ansuman Behera',
  //   speakerDesignation: <> Director Software Engineering, Coinbase</>,
  //   Speakerimage: 'https://ftx-rp.netlify.app/img/ansuman-behera.jpg',
  //   SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/ansuman-behera.webp',
  //   linkedinProfile: 'https://www.linkedin.com/in/ansumanbehera/',
  // },
  {
    speakerName: 'Rajan Bajaj',
    speakerDesignation: <>Founder &amp; CEO, slice</>,
    Speakerimage: 'https://ftx-rp.netlify.app/img/rajan-bajaj.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/rajan-bajaj.webp',
    linkedinProfile: 'https://www.linkedin.com/in/rajanbajaj/',
  },
  {
    speakerName: 'Jaynti Kanani',
    speakerDesignation: <>Co-Founder &amp; CEO, Polygon</>,
    Speakerimage: 'https://ftx-rp.netlify.app/img/jaynti-kanani.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/jaynti-kanani.webp',
    linkedinProfile: 'https://www.linkedin.com/in/jdkanani/',
  },

  {
    speakerName: 'Ajit Kumar',

    speakerDesignation: (
      <>
        Chief Strategy Officer,
        <br />
        KFin Technologies
      </>
    ),
    Speakerimage: 'https://ftx-rp.netlify.app/img/ajit-kumar.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/ajit-kumar.webp',
    linkedinProfile: 'https://www.linkedin.com/in/ajit-kumar79/',
  },

  {
    speakerName: 'Ashish Kashyap',
    speakerDesignation: <>Founder, CEO, INDmoney</>,
    Speakerimage: 'https://ftx-rp.netlify.app/img/ashish-kashyap.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/ashish-kashyap.webp',
    linkedinProfile: 'https://www.linkedin.com/in/ashishkashyap/',
  },

  {
    speakerName: 'Rahul Chari',
    speakerDesignation: <>Founder and CTO, PhonePe</>,
    Speakerimage: 'https://ftx-rp.netlify.app/img/rahul-chari.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/rahul-chari.webp',
    linkedinProfile: 'https://www.linkedin.com/in/rahulchari/',
  },
  {
    speakerName: 'Ishaan Mittal',
    speakerDesignation: <>Managing Director, Sequoia Capital</>,
    Speakerimage: 'https://ftx-rp.netlify.app/img/ishaan-mittal.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/ishaan-mittal.webp',
    linkedinProfile: 'https://www.linkedin.com/in/ishaan-mittal-38128b2b/',
  },
  {
    speakerName: 'Ari Sarker',
    speakerDesignation: (
      <>
        Co-President, Asia Pacific, <br />
        Mastercard
      </>
    ),

    Speakerimage: 'https://ftx-rp.netlify.app/img/ari-sarkar.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/ari-sarkar.webp',
    linkedinProfile: 'https://www.linkedin.com/in/ari-sarker-782a0a3/',
  },

  {
    speakerName: 'Sujith Narayanan',
    speakerDesignation: <>Co-Founder, EpiFi</>,
    Speakerimage: 'https://ftx-rp.netlify.app/img/sujith-narayan.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/sujith-narayan.webp',
    linkedinProfile:
      'https://www.linkedin.com/in/sumit-gwalani/?originalSubdomain=in',
  },
  {
    speakerName: 'Dale Vaz',
    speakerDesignation: <>CTO, Swiggy</>,
    Speakerimage: 'https://ftx-rp.netlify.app/img/dale-vaz.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/dale-vaz.webp',
    linkedinProfile: 'https://www.linkedin.com/in/dalevaz/',
  },

  // {
  //   speakerName: 'Manesh Mahatme',
  //   speakerDesignation: (
  //     <>
  //       Director - Head of <br />
  //       Whatsapp Pay, <br />
  //       Whatsapp
  //     </>
  //   ),
  //   Speakerimage: 'https://ftx-rp.netlify.app/img/manesh-mahatme.jpg',
  //   SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/manesh-mahatme.webp',
  //   linkedinProfile: 'https://in.linkedin.com/in/manesh',
  // },

  {
    speakerName: 'Harsh Jain',
    speakerDesignation: (
      <>
        COO &amp; Co-Founder,
        <br />
        Groww
      </>
    ),
    Speakerimage: 'https://ftx-rp.netlify.app/img/harsh-jain.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/harsh-jain.webp',
    linkedinProfile: 'https://www.linkedin.com/in/harshjainiitd/',
  },
  {
    speakerName: 'Krishnan Vishwanathan',
    speakerDesignation: <>CEO, Kissht</>,
    Speakerimage: 'https://ftx-rp.netlify.app/img/krishnan-vishwanathan.jpg',
    SpeakerimageWebp:
      'https://ftx-rp.netlify.app/img/krishnan-vishwanathan.webp',
    linkedinProfile: 'https://in.linkedin.com/in/krishnan-vishwanathan-76a970',
  },
  // {
  //   speakerName: 'Akshay Aggarwal',
  //   speakerDesignation: <>Investor, Draper Dragon Fund</>,
  //   Speakerimage: 'https://ftx-rp.netlify.app/img/akshay-aggarwal.jpg',
  //   SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/akshay-aggarwal.webp',
  //   linkedinProfile:
  //     'https://www.linkedin.com/in/akshay-aggarwal/?originalSubdomain=in',
  // },
  {
    speakerName: 'Akshay BD',
    speakerDesignation: <>Advisor, Solana Foundation</>,
    Speakerimage: 'https://ftx-rp.netlify.app/img/akshay-bd.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/akshay-bd.webp',
    linkedinProfile: 'https://www.linkedin.com/in/akshay-bd-74202653/',
  },
  {
    speakerName: 'Anuj Kacker',
    speakerDesignation: <>Co-Founder, Freo</>,
    Speakerimage: 'https://ftx-rp.netlify.app/img/anuj-kacker.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/anuj-kacker.webp',
    linkedinProfile: 'https://www.linkedin.com/in/anujkacker1/',
  },
  {
    speakerName: 'Ashish Singhal',
    speakerDesignation: <>Founder &amp; CEO, CoinSwitch</>,
    Speakerimage: 'https://ftx-rp.netlify.app/img/ashish-singhal.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/ashish-singhal.webp',
    linkedinProfile: 'https://www.linkedin.com/in/ashish-singhal-nsit/',
  },
  {
    speakerName: 'Abhishek Poddar',
    speakerDesignation: <>Co-Founder &amp; CEO, Plum</>,
    Speakerimage: 'https://ftx-rp.netlify.app/img/abhishek-poddar.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/abhishek-poddar.webp',
    linkedinProfile: 'https://www.linkedin.com/in/abhishek24/',
  },
  {
    speakerName: 'Sudipta Roy',
    speakerDesignation: <>Group Head, ICICI Bank</>,
    Speakerimage: 'https://ftx-rp.netlify.app/img/sudipta-roy.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/sudipta-roy.webp',
    linkedinProfile: 'https://www.linkedin.com/in/sudiptaroy/',
  },
  {
    speakerName: 'Ayush Bansal',
    speakerDesignation: <>Senior Director Strategy, Razorpay</>,
    Speakerimage: 'https://ftx-rp.netlify.app/img/ayush-bansal.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/ayush-bansal.webp',
    linkedinProfile: 'https://www.linkedin.com/in/ayushbansal13/',
  },

  {
    speakerName: 'Vikram Vaidyanathan',
    speakerDesignation: <>Managing Director, Matrix Partners</>,
    Speakerimage: 'https://ftx-rp.netlify.app/img/vikram-vaidyanathan.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/vikram-vaidyanathan.webp',
    linkedinProfile: 'https://www.linkedin.com/in/vikram-vaidyanathan-0957572/',
  },
  {
    speakerName: 'Sagar Saxena',
    speakerDesignation: (
      <>Founding Team &amp; Sr. Director Enterprise Marketing, Razorpay</>
    ),
    Speakerimage: 'https://ftx-rp.netlify.app/img/sagar-saxena.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/sagar-saxena.webp',
    linkedinProfile: 'https://www.linkedin.com/in/sagarsaxena/',
  },
  {
    speakerName: 'Sohini Rajola',
    speakerDesignation: (
      <>Regional Head - APAC &amp; Middle East, Western Union</>
    ),
    Speakerimage: 'https://ftx-rp.netlify.app/img/sohini-rajola.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/sohini-rajola.webp',
    linkedinProfile: 'https://www.linkedin.com/in/sohini-rajola-9884819/',
  },
  // {
  //   speakerName: 'Arif Khan',
  //   speakerDesignation: <>Chief Digital Officer, NPCI</>,
  //   Speakerimage: 'https://ftx-rp.netlify.app/img/arif-khan.jpg',
  //   SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/arif-khan.webp',
  //   linkedinProfile: 'https://www.linkedin.com/in/arif-khan-aa5a5623/',
  // },
  // {
  //   speakerName: 'Ashish Kashyap',
  //   speakerDesignation: <>Founder, CEO, Indwealth</>,
  //   Speakerimage: 'https://ftx-rp.netlify.app/img/ashish-kashyap-indwealth.jpg',
  //   SpeakerimageWebp:
  //     'https://ftx-rp.netlify.app/img/ashish-kashyap-indwealth.webp',
  //   linkedinProfile: 'https://www.linkedin.com/in/ashishkashyap/',
  // },
  {
    speakerName: 'T R Ramachandran',
    speakerDesignation: <>Group Country Manager, Visa</>,
    Speakerimage: 'https://ftx-rp.netlify.app/img/tr-ramachandran.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/tr-ramachandran.webp',
    linkedinProfile: 'https://www.linkedin.com/in/trramachandran/',
  },
  {
    speakerName: 'Sumit Agarwal',
    speakerDesignation: <>Head of Payments &amp; TripMoney, Go-MMT</>,
    Speakerimage: 'https://ftx-rp.netlify.app/img/sumit-agarwal.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/sumit-agarwal.webp',
    linkedinProfile: 'https://www.linkedin.com/in/sumit577/',
  },
  {
    speakerName: 'Khilan Haria',
    speakerDesignation: <>VP and Head of Payments Product, Razorpay</>,
    Speakerimage: 'https://ftx-rp.netlify.app/img/khilan-haria.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/khilan-haria.webp',
    linkedinProfile: 'https://www.linkedin.com/in/khilanharia/',
  },

  // {
  //   speakerName: 'Govind Soni',
  //   speakerDesignation: <>Co-Founder and CTO, CoinSwitch</>,
  //   Speakerimage: 'https://ftx-rp.netlify.app/img/govind-soni.jpg',
  //   SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/govind-soni.webp',
  //   linkedinProfile: 'abc',
  // },

  // {
  //   speakerName: 'Ajay Prakash Sawhney',
  //   speakerDesignation: <>Secretary, MeitY</>,
  //   Speakerimage: 'https://ftx-rp.netlify.app/img/ajay-prakash-sawhney.jpg',
  //   SpeakerimageWebp:
  //     'https://ftx-rp.netlify.app/img/ajay-prakash-sawhney.webp',
  //   linkedinProfile: 'https://en.wikipedia.org/wiki/Ajay_Prakash_Sawhney',
  // },
  {
    speakerName: 'Vijay Kumar',
    speakerDesignation: <>CEO, Go-Digit GeneralInsurance Ltd</>,
    Speakerimage: 'https://ftx-rp.netlify.app/img/vijay-kumar.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/vijay-kumar.webp',
    linkedinProfile: 'https://www.linkedin.com/in/vijay-kumar-07149274/',
  },
  {
    speakerName: 'Anirvan Saha',
    speakerDesignation: <>Vice President IT, ICICI Lombard</>,
    Speakerimage: 'https://ftx-rp.netlify.app/img/anirvan-saha.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/anirvan-saha.webp',
    linkedinProfile: 'https://in.linkedin.com/in/anirvan-saha-075b9513',
  },
  {
    speakerName: 'Sumit Gupta',
    speakerDesignation: <>Co-Founder &amp; CEO, CoinDCX</>,
    Speakerimage: 'https://ftx-rp.netlify.app/img/sumit-gupta.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/sumit-gupta.webp',
    linkedinProfile: 'https://www.linkedin.com/in/smtgpt/?originalSubdomain=in',
  },

  // {
  //   speakerName: 'Nischal Shetty',
  //   speakerDesignation: <>Founder &amp; CEO, WazirX</>,
  //   Speakerimage: 'https://ftx-rp.netlify.app/img/nischal-shetty.jpg',
  //   SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/nischal-shetty.webp',
  //   linkedinProfile: 'https://www.linkedin.com/in/nischalshetty/',
  // },
  // {
  //   speakerName: 'Kaustubh',
  //   speakerDesignation: <>MAS</>,
  //   Speakerimage: 'https://ftx-rp.netlify.app/img/nischal.jpg',
  //   SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/nischal.webp',
  //   linkedinProfile: 'abc',
  // },
  {
    speakerName: 'Praveen Kumar B',
    speakerDesignation: <>Head of Innovation, Star Health Insurance</>,
    Speakerimage: 'https://ftx-rp.netlify.app/img/praveen-kumar-b.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/praveen-kumar-b.webp',
    linkedinProfile: 'https://www.linkedin.com/in/praveenbenguluru/',
  },
  // {
  //   speakerName: 'Rahul Harkisanka',
  //   speakerDesignation: <>Designation, CRED</>,
  //   Speakerimage: 'https://ftx-rp.netlify.app/img/rahul-harikisanka.jpg',
  //   SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/rahul-harikisanka.webp',
  //   linkedinProfile: 'https://www.linkedin.com/in/rahulharkisanka/',
  // },
  {
    speakerName: 'Vedanarayanan V',
    speakerDesignation: <>SME &amp; Startup Business Head, Razorpay</>,
    Speakerimage: 'https://ftx-rp.netlify.app/img/vedanarayanan-v.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/vedanarayanan-v.webp',
    linkedinProfile: 'https://www.linkedin.com/in/vedanarayananvedantham/',
  },
  {
    speakerName: 'Raghu Ramanujam',
    speakerDesignation: <>Director of Product, Flipkart</>,
    Speakerimage: 'https://ftx-rp.netlify.app/img/raghu-ramanujan.jpg',
    SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/raghu-ramanujan.webp',
    linkedinProfile: 'https://www.linkedin.com/in/raghuramanujam/',
  },
  // {
  //   speakerName: 'Sagar Saxena',
  //   speakerDesignation: <>Designation, Razorpay</>,
  //   Speakerimage: 'https://ftx-rp.netlify.app/img/sagar-saxena.jpg',
  //   SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/sagar-saxena.webp',
  //   linkedinProfile: 'https://www.linkedin.com/in/sagarsaxena/',
  // },
  // {
  //   speakerName: 'Bhavin Turakhia',
  //   speakerDesignation: <>CEO, Zeta</>,
  //   Speakerimage: 'https://ftx-rp.netlify.app/img/bhavin-turakhia.jpg',
  //   SpeakerimageWebp: 'https://ftx-rp.netlify.app/img/bhavin-turakhia.webp',
  //   linkedinProfile: 'https://www.linkedin.com/in/bhavin79/',
  // },
].map(
  (
    {
      speakerDesignation,
      speakerName,
      Speakerimage,
      SpeakerimageWebp,
      linkedinProfile,
    },
    id,
  ) => ({
    speakerDesignation,
    speakerName,
    Speakerimage,
    SpeakerimageWebp,
    linkedinProfile,
    id,
  }),
);

export const videoLnks = [
  '',
  'https://www.youtube.com/embed/TJ1Gu8Zv99o',
  'https://www.youtube.com/embed/fRvwl6D-kDk',
  'https://www.youtube.com/embed/Fwj3Ye3kf1M',
];
